import { selectPayrollCompany } from '../payroll.selectors'
import { LocationsPanel } from './LocationsPanel'
import { useBankAccount } from '../helpers'
import { Button, Text, Link, Alert, Icon, Separator } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { faUniversity, faUser } from '@fortawesome/pro-regular-svg-icons'
export const CompanySettingsTab = ({
  goToLocations,
}: {
  goToLocations: () => void
}) => {
  const company = useReselector(selectPayrollCompany)
  const bankAccount = useBankAccount()

  if (!company) {
    return null
  }

  const { primary_signatory } = company

  return (
    <div className="flex flex-col gap-4">
      <Alert>
        This page holds important information related to your company, which
        allows us to run payroll in a compliant manner. Please keep it up to
        date!
      </Alert>

      <LocationsPanel title="Company Location" />

      <Button
        variant="secondary"
        onClick={goToLocations}
        size="sm"
        className="w-full sm:w-1/3"
      >
        View all Company Locations
      </Button>

      <Separator />

      <Text variant={TypographyStyles.BODY_LG}>
        <b className="inline-flex items-center gap-2">
          <Icon icon={faUniversity} />
          Business Bank Account For Payroll
        </b>
      </Text>

      <Text variant={TypographyStyles.BODY_SM}>
        We will pull money from this bank account when running payroll.
      </Text>

      {bankAccount && (
        <>
          <Text>
            <b>{bankAccount.account_type}</b>
          </Text>
          <Text>Routing Number: {bankAccount.routing_number}</Text>
          <Text>Account Number: {bankAccount.hidden_account_number}</Text>
          <Text>
            Need to update this bank account?{' '}
            <Link href="/conversations">Contact the Heard Team</Link>
          </Text>
        </>
      )}

      <Separator />

      {primary_signatory && (
        <>
          <Text variant={TypographyStyles.BODY_MD}>
            <b className="inline-flex items-center gap-2">
              <Icon icon={faUser} />
              Company Signatory
            </b>
          </Text>
          <Text>
            This is the person that has authority to sign documents for your
            Company. We recommend this be you.
          </Text>
          <Text>
            <b>
              {primary_signatory.first_name} {primary_signatory.last_name}
            </b>
          </Text>
          <Text>{primary_signatory.email}</Text>
          <Text>
            Need to update this signatory?{' '}
            <Link href="/conversations">Contact the Heard Team</Link>
          </Text>
        </>
      )}
    </div>
  )
}
